<template>
<main class="container">
    <rich-pretty-info>
        <template slot="image">
            <img src="../../assets/img/illustrations/confirmation-mail.svg" height="200" width="200"/>
        </template>
        <template slot="content">
            <h1>Veuillez vérifier votre boîte mail !</h1>
            <h3>
                Votre demande a été prise en compte.<br>
                Nous vous avons envoyé un e-mail pour valider votre adresse e-mail et finaliser la création de votre compte.<br>
                Si vous ne recevez pas l'email, veuillez vérifier dans votre boîte de spams.
            </h3>
        </template>
<!--        <template slot="actions">-->
<!--            <p>Cela fait plus de 10 minutes et vous n'avez pas reçu d'email ?<br>-->
<!--                Vous avez vérifié si vous ne l'avez pas reçu dans vos spams et toujours rien ?<br>-->
<!--            </p>-->
<!--            <uni-button class="button&#45;&#45;secondary">-->
<!--                Renvoyer un e-mail de confirmation-->
<!--            </uni-button>-->
<!--        </template>-->
    </rich-pretty-info>
</main>
</template>

<script>
    import RichPrettyInfo from "../../components/c-blocks/RichPrettyInfo";
    import UniCtaLink from "../../components/a-elements/UniCtaLink";
    import UniButton from "../../components/a-elements/UniButton";
    export default {
        name: "success",
        components: {UniButton, UniCtaLink, RichPrettyInfo}
    }
</script>

<style scoped lang="scss">
h1{
    margin-bottom: 8px;
}
</style>
